import { ViewModel } from 'mobx-utils';
import { observable } from 'mobx';

import getFilterStore from '@stores/FilterStore';

import type { ObservableMap } from 'mobx';
import type { IViewModel } from 'mobx-utils';

const FilterStore = getFilterStore();

class ShallowViewModel<T> extends ViewModel<T> {
  localValues: ObservableMap<keyof T, T[keyof T]> = observable.map({}, { deep: false });
}

export function createShallowViewModel<T>(model: T): T & IViewModel<T> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return new ShallowViewModel(model) as any;
}

const filterViewModel = createShallowViewModel(FilterStore.filters);

export { filterViewModel };
